module.exports = __webpack_public_path__ + "static/media/024.9f1876b7.jpg";